module.exports = __webpack_public_path__ + "static/media/SJSU-logo.59d0092a.png";